import React from 'react';
import _ from 'lodash';

import {
  AsnSettingsWidgetDocument,
  SaveAsnFormatPropertyInput,
  useAsnSettingsWidgetQuery,
  useSaveAsnFormatMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useAsnSettingsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          properties: _.map(tuple.data?.asnFormat, (format): types.IAsnProperty => {
            const prop = _.find(tuple.data?.orderProperties, prop => prop.name === format.property.name);
            return {
              customColumnHeader: format.customColumnHeader,
              defaultValue: format.defaultValue,
              orderProperty: prop ? {
                id: prop.name,
                displayName: prop.displayName
              } : null
            };
          })
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveAsnFormat(storeId: string) {
  const [fnMutate, tuple] = useSaveAsnFormatMutation({
    refetchQueries: [
      {
        query: AsnSettingsWidgetDocument,
        variables: {
          storeId
        }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      fnMutate({
        variables: {
          input: {
            storeId,
            properties: _.map(formState.properties, (prop): SaveAsnFormatPropertyInput => ({
              customColumnHeader: prop.customColumnHeader,
              propertyName: prop.orderProperty?.id ?? 'customer_email',
              defaultValue: prop.defaultValue
            }))
          }
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
